export const content = {
	id: 'about-us',
	title: "Совместные усилия экспертов в области IT и медицины направлены на цифровизацию государственного и коммерческого здравоохранения страны: создание продуктов на основе искусственного интеллекта и больших данных.\n\nТакие продукты помогут снизить нагрузку на врачей и сделать диагностику заболеваний и патологий эффективнее.",
}